module.exports = __webpack_public_path__ + "static/img/naturalCircle2.e71c2f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle2.svg
// module id = Xm3y
// module chunks = 1